import { IUtente } from "./../interfaces/IUtente";
import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  AfterViewInit,
} from "@angular/core";
import * as Enum from "../utils/enums";
import * as Constants from "../utils/constants";
import * as Moment from "moment";
import { IRichiesta } from "../interfaces/IRichiesta";
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from "@angular/animations";
import { IDocumento } from "../interfaces/IDocumento";
import { ICommessa } from "../interfaces/ICommessa";
import { Table } from "primeng/table";
import { IAccesso, ISito } from "../interfaces/IAccesso";
import * as moment from "moment";
import { ICaricamentoMassivo } from "../interfaces/ICaricamentoMassivo";

@Component({
  selector: "app-data-table",
  templateUrl: "./data-table.component.html",
  styleUrls: ["./data-table.component.css"],
  animations: [
    trigger("rowExpansionTrigger", [
      state(
        "void",
        style({
          transform: "translateX(-10%)",
          opacity: 0,
        })
      ),
      state(
        "active",
        style({
          transform: "translateX(0)",
          opacity: 1,
        })
      ),
      transition("* <=> *", animate("400ms cubic-bezier(0.86, 0, 0.07, 1)")),
    ]),
  ],
})
export class DataTableComponent implements OnInit, AfterViewInit {
  @Input() tableHeader: string;
  @Input() dataSource: any[]; //data row
  @Input() itemType: Enum.DATA_TABLE_TYPE_ENUM;
  @Input() rowsPerPage: number;
  @Input() fromFullTextSearch: boolean; //for hide default table
  @Input() selectedItem: any; // single item selected
  @Input() listaSelected: any[]; // list item selected
  @Input() columnEditable: boolean; // To change a value in a cell
  @Input() sitiAccessoCantiere: ISito[]; // elenco dei Siti di accesso per il cantiere (per tabella accessi Mezzi e Persone)

  @Output() onRowSelected: EventEmitter<any> = new EventEmitter<any>(); // single row selected
  @Output() onRowUnselected: EventEmitter<any> = new EventEmitter<any>(); // single row unselected
  @Output() onActionButtonClicked: EventEmitter<any> = new EventEmitter<any>(); // action button clicked
  @Output() onActionLinkClicked: EventEmitter<any> = new EventEmitter<any>(); // action link clicked
  @Output() onShowButtonClicked: EventEmitter<any> = new EventEmitter<any>(); // action button clicked
  @Output() onLinkButtonClicked: EventEmitter<any> = new EventEmitter<any>(); // link button clicked
  @Output() onStopActivityButtonClicked: EventEmitter<any> =
    new EventEmitter<any>(); // stop activity button clicked
  @Output() onDuplicateButtonClicked: EventEmitter<any> =
    new EventEmitter<any>(); // duplicate button clicked
  @Output() onDeleteButtonClicked: EventEmitter<any> = new EventEmitter<any>(); // delete button clicked
  @Output() onClickSearchClicked: EventEmitter<any> = new EventEmitter<any>(); // from full text search
  @Output() onValidaAccessoClicked: EventEmitter<any> = new EventEmitter<any>(); // valida button clicked
  @Output() onInfoValidazioneClicked: EventEmitter<any> =
    new EventEmitter<any>(); // info validazione button clicked

  @ViewChild("dt") dt: Table;

  columnWidths: number[] = [];
  cols: any[]; //header col
  searchString: string; //input search text
  totalRecords: number;
  DTT = Enum.DATA_TABLE_TYPE_ENUM;
  inputValid: boolean = false; //for FULL_TEXT_SEARCH disabled
  sitoSelected: ISito;
  editing: boolean;
  isAggiudicatario: boolean; // Variabile che identifica se l'utente loggato è Aggiudicatario
  isAffidatario: boolean; // Variabile che identifica se l'utente loggato è Affidatario
  isReferente: boolean = false; // Variabile che identifica se l'utente loggato è Referente
  isAdmin: boolean = false; // Variabile che identifica se l'utente loggato è Referente
  tooltipDisabled: boolean = true; // Modifica del 06/11/2024 Var che abilita/disabilita Tooltip

  constructor() { }

  ngOnInit() {
    let userRole = localStorage.getItem(Constants.LS_USER_ROLE);
    if (userRole == Enum.USER_TYPE_ENUM.AGGIUDICATARIO) {
      this.isAggiudicatario = true;
    } else if (userRole == Enum.USER_TYPE_ENUM.REFERENTE) {
      this.isReferente = true;
    } else if (userRole == Enum.USER_TYPE_ENUM.AFFIDATARIO) {
      this.isAffidatario = true;
    } else if (userRole == Enum.USER_TYPE_ENUM.AMMINISTRATORE) {
      this.isAdmin = true;
    }

    this.setHeaders();
  }

  /**
   * Modifica del 13/11/2024 - Aggiunto ngAfterViewInit per il calcolo della larghezza delle colonne delle tabelle
   */
  ngAfterViewInit() {
    this.updateColumnWidths();
  }

  /**
   * set header of table
   * Modifica del 12/11/2024 - Riviste % larghezza colonne
   * Modifica del 03/12/2024 - Riviste % larghezza colonne
   */
  setHeaders() {
    this.cols = [];
    if (this.itemType == Enum.DATA_TABLE_TYPE_ENUM.COMMESSA) {
      if (
        localStorage.getItem(Constants.LS_USER_ROLE) ==
        Enum.USER_TYPE_ENUM.AFFIDATARIO ||
        localStorage.getItem(Constants.LS_USER_ROLE) ==
        Enum.USER_TYPE_ENUM.GVS ||
        localStorage.getItem(Constants.LS_USER_ROLE) == Enum.USER_TYPE_ENUM.CSE
      ) {
        this.cols = [
          {
            type: "EXPAND_ARROW",
            field: "expand_arrow",
            header: "",
            width: "3em",
          },
          { field: "count", header: "Richieste", width: "10em" },
          { field: "Codice", header: "Codice" },
          { field: "Nome", header: "Nome" },
          { field: "Descrizione", header: "Descrizione", width: "26%" },
          { field: "Aggiudicatario.Ragione_sociale", header: "Aggiudicatario" },
          { field: "Responsabile", header: "Responsabile" },
          { field: "Data_fine_lavori", header: "Fine lavori", width: "8%" },
          {
            type: "LINK_BUTTON",
            field: "LinkGIS",
            header: "Link GIS",
            icon: "pi pi-external-link",
          },
          {
            type: "ACTION_BUTTON",
            field: "action_button",
            header: "Modifica",
            icon: "pi pi-pencil",
          } /* ,
          { type: 'DELETE_BUTTON', field: 'action_button', header: 'Elimina', icon: 'pi pi-trash' } */,
        ];
      } else if (
        localStorage.getItem(Constants.LS_USER_ROLE) ==
        Enum.USER_TYPE_ENUM.AMMINISTRATORE
      ) {
        this.cols = [
          {
            type: "EXPAND_ARROW",
            field: "expand_arrow",
            header: "",
            width: "3em",
          },
          { field: "count", header: "Richieste", width: "10em" },
          { field: "Codice", header: "Codice" },
          { field: "Nome", header: "Nome" },
          { field: "Descrizione", header: "Descrizione", width: "26%" },
          { field: "Aggiudicatario.Ragione_sociale", header: "Aggiudicatario" },
          { field: "Responsabile", header: "Responsabile" },
          { field: "Data_fine_lavori", header: "Fine lavori", width: "8%" },
          {
            type: "LINK_BUTTON",
            field: "LinkGIS",
            header: "Link GIS",
            icon: "pi pi-external-link",
          },
          {
            type: "DELETE_BUTTON",
            field: "action_button",
            header: "Elimina",
            icon: "pi pi-trash",
          },
        ];
      } else {
        this.cols = [
          {
            type: "EXPAND_ARROW",
            field: "expand_arrow",
            header: "",
            width: "3em",
          },
          { field: "Codice", header: "Codice" },
          { field: "Nome", header: "Nome" },
          { field: "Descrizione", header: "Descrizione", width: "26%" },
          { field: "Aggiudicatario.Ragione_sociale", header: "Aggiudicatario" },
          { field: "Responsabile", header: "Responsabile" },
          { field: "Data_fine_lavori", header: "Fine lavori", width: "8%" },
          {
            type: "LINK_BUTTON",
            field: "LinkGIS",
            header: "Link GIS",
            icon: "pi pi-external-link",
          },
        ];
      }
    } else if (this.itemType == Enum.DATA_TABLE_TYPE_ENUM.COMMESSA_NO_COUNT) {
      if (
        localStorage.getItem(Constants.LS_USER_ROLE) ==
        Enum.USER_TYPE_ENUM.AFFIDATARIO ||
        localStorage.getItem(Constants.LS_USER_ROLE) ==
        Enum.USER_TYPE_ENUM.GVS
      ) {
        this.cols = [
          {
            type: "EXPAND_ARROW",
            field: "expand_arrow",
            header: "",
            width: "3em",
          },
          { field: "Codice", header: "Codice" },
          { field: "Nome", header: "Nome" },
          { field: "Descrizione", header: "Descrizione", width: "26%" },
          { field: "Aggiudicatario.Ragione_sociale", header: "Aggiudicatario" },
          { field: "Responsabile", header: "Responsabile" },
          { field: "Data_fine_lavori", header: "Fine lavori", width: "8%" },
          {
            type: "LINK_BUTTON",
            field: "LinkGIS",
            header: "Link GIS",
            icon: "pi pi-external-link",
          },
          {
            type: "ACTION_BUTTON",
            field: "action_button",
            header: "Modifica",
            icon: "pi pi-pencil",
          },
        ];
      } else {
        this.cols = [
          {
            type: "EXPAND_ARROW",
            field: "expand_arrow",
            header: "",
            width: "3em",
          },
          { field: "Codice", header: "Codice" },
          { field: "Nome", header: "Nome" },
          { field: "Descrizione", header: "Descrizione", width: "26%" },
          { field: "Aggiudicatario.Ragione_sociale", header: "Aggiudicatario" },
          { field: "Responsabile", header: "Responsabile" },
          { field: "Data_fine_lavori", header: "Fine lavori", width: "8%" },
          {
            type: "LINK_BUTTON",
            field: "LinkGIS",
            header: "Link GIS",
            icon: "pi pi-external-link",
          },
        ];
      }
    } else if (this.itemType == Enum.DATA_TABLE_TYPE_ENUM.COMMESSA_SAL) {
      if (
        localStorage.getItem(Constants.LS_USER_ROLE) !=
        Enum.USER_TYPE_ENUM.ESECUTORE
      ) {
        this.cols = [
          { field: "Codice", header: "Codice" },
          { field: "Nome", header: "Nome" },
          { field: "Descrizione", header: "Descrizione", width: "26%" },
          { field: "Aggiudicatario.Ragione_sociale", header: "Aggiudicatario" },
          { field: "Responsabile", header: "Responsabile" },
          { field: "Data_fine_lavori", header: "Fine lavori", width: "8%" },
          {
            type: "ACTION_BUTTON",
            field: "action_button",
            header: "SAL & Pagamenti",
            icon: "pi pi-money-bill",
          },
        ];
      } else {
        this.cols = [
          { field: "Codice", header: "Codice" },
          { field: "Nome", header: "Nome" },
          { field: "Descrizione", header: "Descrizione", width: "25%" },
          { field: "Aggiudicatario.Ragione_sociale", header: "Aggiudicatario" },
          { field: "Responsabile", header: "Responsabile" },
          { field: "Data_fine_lavori", header: "Fine lavori", width: "8%" },
        ];
      }
    } else if (this.itemType == Enum.DATA_TABLE_TYPE_ENUM.SCADENZARIO) {
      this.cols = [
        {
          type: "EXPAND_ARROW",
          field: "expand_arrow",
          header: "",
          width: "3em",
        },
        { field: "Nome", header: "Nome" },
        { field: "Descrizione", header: "Descrizione", width: "35%" },
        { field: "Nome_template", header: "Nome template" },
        { field: "Data_scadenza", header: "Scadenza", width: "10%" },
        { field: "Autore", header: "Azienda" },
        { type: "MARKER", field: "Stato", header: "Stato", width: "20%" },
      ];
    } else if (this.itemType == Enum.DATA_TABLE_TYPE_ENUM.DOCUMENTO) {
      if (
        localStorage.getItem(Constants.LS_USER_ROLE) ==
        Enum.USER_TYPE_ENUM.PREFETTURA ||
        localStorage.getItem(Constants.LS_USER_ROLE) == Enum.USER_TYPE_ENUM.DL
      ) {
        this.cols = [
          {
            type: "EXPAND_ARROW",
            field: "expand_arrow",
            header: "",
            width: "3em",
          },
          { field: "Nome", header: "Nome" },
          { field: "Descrizione", header: "Descrizione", width: "40%" },
          { field: "Tipologia", header: "Tipologia", width: "10%" },
          { field: "Data_scadenza", header: "Scadenza", width: "10%" },
          { type: "MARKER", field: "Stato", header: "Stato", width: "15%" },
        ];
      } else {
        this.cols = [
          {
            type: "EXPAND_ARROW",
            field: "expand_arrow",
            header: "",
            width: "3em",
          },
          { field: "Nome", header: "Nome" },
          { field: "Descrizione", header: "Descrizione", width: "40%" },
          { field: "Tipologia", header: "Tipologia", width: "10%" },
          { field: "Data_scadenza", header: "Scadenza", width: "10%" },
          { type: "MARKER", field: "Stato", header: "Stato", width: "15%" },
          {
            type: "ACTION_BUTTON",
            field: "action_button",
            header: "Mostra PDF",
            icon: "pi pi-file",
          },
        ];
      }
    } else if (this.itemType == Enum.DATA_TABLE_TYPE_ENUM.DOCUMENTO_ESECUTORE) {
      this.cols = [
        {
          type: "EXPAND_ARROW",
          field: "expand_arrow",
          header: "",
          width: "3em",
        },
        { field: "Nome", header: "Nome" },
        { field: "Descrizione", header: "Descrizione", width: "40%" },
        { field: "Tipologia", header: "Tipologia", width: "10%" },
        { field: "Data_scadenza", header: "Scadenza", width: "10%" },
        { type: "MARKER", field: "Stato", header: "Stato", width: "15%" },
        {
          type: "ACTION_BUTTON",
          field: "action_button",
          header: "Mostra PDF",
          icon: "pi pi-file",
        },
      ];
    } else if (
      this.itemType == Enum.DATA_TABLE_TYPE_ENUM.UPLOADS_MEZZI ||
      this.itemType == Enum.DATA_TABLE_TYPE_ENUM.UPLOADS_PERSONE
    ) {
      this.cols = [
        {
          type: "EXPAND_ARROW",
          field: "expand_arrow",
          header: "",
          width: "3em",
        },
        { field: "NomeFileSorgente", header: "Nome File" },
        { field: "DataInizioCaricamento", header: "Data Caricamento" },
        { field: "DataFineCaricamento", header: "Data Fine" },
        {
          type: "NUMBER",
          field: "TotaleRecordInFile",
          header: "Totali",
          width: "8%",
        },
        {
          type: "NUMBER",
          field: "TotaleCaricati",
          header: "Caricati",
          width: "8%",
        },
        {
          type: "NUMBER",
          field: "TotaleScarti",
          header: "Scarti",
          width: "8%",
        },
        {
          type: "ACTION_BUTTON",
          field: "action_button",
          header: "Download File",
          icon: "pi pi-file",
        },
      ];
    } else if (this.itemType == Enum.DATA_TABLE_TYPE_ENUM.DOCUMENTO_FULL_TEXT) {
      if (
        localStorage.getItem(Constants.LS_USER_ROLE) ==
        Enum.USER_TYPE_ENUM.PREFETTURA ||
        localStorage.getItem(Constants.LS_USER_ROLE) == Enum.USER_TYPE_ENUM.DL
      ) {
        this.cols = [
          {
            type: "EXPAND_ARROW",
            field: "expand_arrow",
            header: "",
            width: "3em",
          },
          { field: "Codice", header: "Intervento", width: "10%" },
          { field: "Nome", header: "Nome" },
          { field: "Descrizione", header: "Descrizione", width: "25%" },
          { field: "Tipologia", header: "Tipologia", width: "13%" },
          { field: "Esecutore", header: "Contratto Per", width: "8%" },
          { field: "DataApprovazione", header: "Approv.", width: "10%" },
          { field: "Data_scadenza", header: "Scadenza", width: "10%" },
          { field: "Autore", header: "Autore" },
        ];
      } else {
        this.cols = [
          {
            type: "EXPAND_ARROW",
            field: "expand_arrow",
            header: "",
            width: "3em",
          },
          { field: "Codice", header: "Intervento", width: "10%" },
          { field: "Nome", header: "Nome" },
          { field: "Descrizione", header: "Descrizione", width: "25%" },
          { field: "Tipologia", header: "Tipologia", width: "13%" },
          { field: "Esecutore", header: "Contratto Per", width: "8%" },
          { field: "DataApprovazione", header: "Approv.", width: "10%" },
          { field: "Data_scadenza", header: "Scadenza", width: "10%" },
          { field: "Autore", header: "Autore" },
          {
            type: "ACTION_BUTTON",
            field: "action_button",
            header: "Mostra PDF",
            icon: "pi pi-file",
          },
        ];
      }
    } else if (this.itemType == Enum.DATA_TABLE_TYPE_ENUM.PERSONA) {
      this.cols = [
        { field: "Nome", header: "Nome" },
        { field: "Cognome", header: "Cognome" },
        { field: "Codice_fiscale", header: "Codice Fiscale" },
        { field: "Qualifica", header: "Qualifica" },
      ];
    } else if (this.itemType == Enum.DATA_TABLE_TYPE_ENUM.PERSONA_CRUD) {
      this.cols = [
        { field: "Nome", header: "Nome" },
        { field: "Cognome", header: "Cognome" },
        { field: "Codice_fiscale", header: "Codice Fiscale" },
        { field: "Qualifica", header: "Qualifica" },
        {
          type: "ACTION_BUTTON",
          field: "action_button",
          header: "Modifica",
          icon: "pi pi-pencil",
        },
        {
          type: "STOP_ACTIVITY_BUTTON",
          field: "action_button",
          header: "Interrompi attività",
          icon: "pi pi-times",
        },
      ];
    } else if (this.itemType == Enum.DATA_TABLE_TYPE_ENUM.MEZZO) {
      this.cols = [
        { field: "Tipo", header: "Tipo" },
        { field: "Targa", header: "Targa" },
        { field: "Marca", header: "Marca" },
        { field: "Modello", header: "Modello" },
        { field: "Definizione", header: "Definizione" },
      ];
    } else if (this.itemType == Enum.DATA_TABLE_TYPE_ENUM.MEZZO_CRUD) {
      this.cols = [
        { field: "Targa", header: "Targa" },
        { field: "Marca", header: "Marca" },
        { field: "Modello", header: "Modello" },
        { field: "Tipo", header: "Tipo" },
        { field: "Definizione", header: "Definizione" },
        {
          type: "ACTION_BUTTON",
          field: "action_button",
          header: "Modifica",
          icon: "pi pi-pencil",
        },
        {
          type: "STOP_ACTIVITY_BUTTON",
          field: "action_button",
          header: "Interrompi attività",
          icon: "pi pi-times",
        },
      ];
    } else if (this.itemType == Enum.DATA_TABLE_TYPE_ENUM.ESECUTORE) {
      this.cols = [
        { field: "Ragione_sociale", header: "Rag. Sociale" },
        { field: "Partita_IVA", header: "Partita IVA" },
        { field: "Indirizzo", header: "Indirizzo" },
        { field: "Email", header: "Email" },
        {
          type: "ACTION_BUTTON",
          field: "action_button",
          header: "Pagamenti",
          icon: "pi pi-money-bill",
        },
      ];
    } else if (this.itemType == Enum.DATA_TABLE_TYPE_ENUM.ESECUTORE_CRUD) {
      this.cols = [
        { field: "Ragione_sociale", header: "Rag. Sociale" },
        { field: "Partita_IVA", header: "Partita IVA" },
        { field: "Indirizzo", header: "Indirizzo" },
        { field: "Email", header: "Email" },
        {
          type: "ACTION_BUTTON",
          field: "action_button",
          header: "Modifica",
          icon: "pi pi-pencil",
        },
        {
          type: "DELETE_BUTTON",
          field: "action_button",
          header: "Elimina",
          icon: "pi pi-trash",
        },
      ];
    } else if (this.itemType == Enum.DATA_TABLE_TYPE_ENUM.AGGIUDICATARIO) {
      if (
        localStorage.getItem(Constants.LS_USER_ROLE) !=
        Enum.USER_TYPE_ENUM.CSE &&
        localStorage.getItem(Constants.LS_USER_ROLE) !=
        Enum.USER_TYPE_ENUM.DL &&
        localStorage.getItem(Constants.LS_USER_ROLE) !=
        Enum.USER_TYPE_ENUM.AMMINISTRATORE
      ) {
        this.cols = [
          {
            type: "EXPAND_ARROW",
            field: "expand_arrow",
            header: "",
            width: "3em",
          },
          { field: "Ragione_sociale", header: "Rag. Sociale" },
          { field: "Commessa", header: "Commessa" },
          { field: "Partita_IVA", header: "Partita IVA" },
          { field: "Codice_fiscale", header: "Codice fiscale" },
          { field: "Comune,Provincia", header: "Comune" },
          { field: "Codice_ISTAT", header: "Codice ISTAT" },
          { field: "Email", header: "Email" },
          { field: "Telefono", header: "Telefono" },
          {
            type: "ACTION_BUTTON",
            field: "action_button",
            header: "Modifica",
            icon: "pi pi-pencil",
          },
        ];
      } else {
        this.cols = [
          {
            type: "EXPAND_ARROW",
            field: "expand_arrow",
            header: "",
            width: "3em",
          },
          { field: "Ragione_sociale", header: "Rag. Sociale" },
          { field: "Commessa", header: "Commessa" },
          { field: "Partita_IVA", header: "Partita IVA" },
          { field: "Codice_fiscale", header: "Codice fiscale" },
          { field: "Comune,Provincia", header: "Comune" },
          { field: "Codice_ISTAT", header: "Codice ISTAT" },
          { field: "Email", header: "Email" },
          { field: "Telefono", header: "Telefono" },
        ];
      }
    } else if (this.itemType == Enum.DATA_TABLE_TYPE_ENUM.RICHIESTA) {
      if (
        localStorage.getItem(Constants.LS_USER_ROLE) ==
        Enum.USER_TYPE_ENUM.AGGIUDICATARIO ||
        localStorage.getItem(Constants.LS_USER_ROLE) ==
        Enum.USER_TYPE_ENUM.ESECUTORE
      ) {
        this.cols = [
          {
            field: "TipoContratto.TipoRichiesta.Nome",
            header: "Tipo Richiesta",
          },
          { field: "TipoContratto.Nome", header: "Tipo Contratto" },
          { field: "Riferimento", header: "Riferimento" },
          { field: "Esecutore.Ragione_sociale", header: "Contratto Per" },
          { field: "Data_creazione", header: "Creazione", width: "10%" },
          {
            type: "MARKER",
            field: "StatoRichiesta.Nome",
            header: "Stato",
            width: "15%",
          },
          {
            type: "INFO_BUTTON",
            field: "action_button",
            header: "Note",
            icon: "pi pi-info",
          },
          {
            type: "DELETE_BUTTON",
            field: "action_button",
            header: "Elimina",
            icon: "pi pi-trash",
          },
          {
            type: "ACTION_BUTTON",
            field: "action_button",
            header: "Invia",
            icon: "pi pi-arrow-right",
          },
        ];
      } else {
        this.cols = [
          {
            field: "TipoContratto.TipoRichiesta.Nome",
            header: "Tipo Richiesta",
          },
          { field: "TipoContratto.Nome", header: "Tipo Contratto" },
          { field: "Riferimento", header: "Riferimento" },
          { field: "Esecutore.Ragione_sociale", header: "Contratto Per" },
          { field: "Data_creazione", header: "Creazione", width: "10%" },
          {
            type: "MARKER",
            field: "StatoRichiesta.Nome",
            header: "Stato",
            width: "15%",
          },
          {
            type: "DELETE_BUTTON",
            field: "action_button",
            header: "Elimina",
            icon: "pi pi-trash",
          },
          {
            type: "ACTION_BUTTON",
            field: "action_button",
            header: "Invia",
            icon: "pi pi-arrow-right",
          },
        ];
      }
    } else if (
      this.itemType == Enum.DATA_TABLE_TYPE_ENUM.RICHIESTA_TAB_ESECUTORI
    ) {
      this.cols = [
        { field: "Intervento", header: "Intervento" },
        { field: "Tipo_Richiesta", header: "Tipo Richiesta" },
        { field: "Tipo_Contratto", header: "Tipo Contratto" },
        { field: "Riferimento", header: "Riferimento" },
        { field: "Autore", header: "Autore" },
        { field: "Contratto_Per", header: "Contratto Per" },
        { field: "Creazione", header: "Creazione", width: "10%" },
      ];
    } else if (this.itemType == Enum.DATA_TABLE_TYPE_ENUM.ACCESSO_PROGRAMMATO) {
      if (
        localStorage.getItem(Constants.LS_USER_ROLE) ==
        Enum.USER_TYPE_ENUM.REFERENTE
      ) {
        this.cols = [
          { field: "Riferimento", header: "Riferimento" },
          { field: "Codice", header: "Codice" },
          { field: "Tipo", header: "Tipo" },
          { field: "Data", header: "Data", width: "15%" },
          { field: "Sito", header: "Sito", width: "30%" },
          {
            type: "VALIDATION_ACCESSO_BUTTON",
            field: "action_button",
            header: "",
            icon: "pi pi-check",
            width: "10%",
          },
        ];
      } else {
        this.cols = [
          { field: "Riferimento", header: "Riferimento" },
          { field: "Codice", header: "Codice", width: "20%" },
          { field: "Tipo", header: "Tipo" },
          { field: "Data", header: "Data", width: "15%" },
          { field: "Sito", header: "Sito", width: "20%" },
          {
            type: "EDITABLE_SITI_BUTTON",
            field: "action_button",
            header: "Modifica",
            icon: "pi pi-pencil",
          },
        ];
      }
    } else if (this.itemType == Enum.DATA_TABLE_TYPE_ENUM.ACCESSO_EFFETTUATO) {
      this.cols = [
        { field: "Codice", header: "Codice", width: "20%" },
        { field: "Tipo", header: "Tipo" },
        { field: "Coordinate", header: "Coordinate" },
        { field: "Data", header: "Data", width: "20%" },
        { field: "Sito", header: "Sito" },
      ];
    } else if (this.itemType == Enum.DATA_TABLE_TYPE_ENUM.CANTIERE) {
      if (
        localStorage.getItem(Constants.LS_USER_ROLE) ==
        Enum.USER_TYPE_ENUM.ESECUTORE
      ) {
        this.cols = [
          {
            type: "EXPAND_ARROW",
            field: "expand_arrow",
            header: "",
            width: "3em",
          },
          { field: "Nome", header: "Nome" },
          { field: "Nazione", header: "Nazione" },
          { field: "Provincia", header: "Provincia" },
          { field: "Citta", header: "Citta" },
          { field: "Indirizzo", header: "Indirizzo" },
        ];
      } else {
        this.cols = [
          {
            type: "EXPAND_ARROW",
            field: "expand_arrow",
            header: "",
            width: "3em",
          },
          { field: "Nome", header: "Nome" },
          { field: "Nazione", header: "Nazione" },
          { field: "Provincia", header: "Provincia" },
          { field: "Citta", header: "Citta" },
          { field: "Indirizzo", header: "Indirizzo" },
          {
            type: "ACTION_BUTTON",
            field: "action_button",
            header: "Storico Accessi",
            icon: "pi pi-users",
          },
        ];
      }
    } else if (
      this.itemType == Enum.DATA_TABLE_TYPE_ENUM.AGGIUDICATARIO_FILIERA
    ) {
      this.cols = [
        { field: "Partita_IVA", header: "Partita IVA" },
        { field: "Ragione_sociale", header: "Rag. Sociale" },
        { field: "Indirizzo", header: "Indirizzo" },
        { field: "Provincia", header: "Provincia" },
        { field: "Nazione", header: "Nazione" },
        { field: "Email", header: "Email" },
      ];
    } else if (this.itemType == Enum.DATA_TABLE_TYPE_ENUM.PERSONA_ACCESSI) {
      let userRole = localStorage.getItem(Constants.LS_USER_ROLE);
      // only aggiudicatario and esecutore can stop activity
      if (
        userRole == Enum.USER_TYPE_ENUM.AGGIUDICATARIO ||
        userRole == Enum.USER_TYPE_ENUM.ESECUTORE
      ) {
        this.cols = [
          { field: "Nome", header: "Nome" },
          { field: "Cognome", header: "Cognome" },
          { field: "Codice_fiscale", header: "Codice Fiscale" },
          { field: "Ragione_sociale", header: "Azienda" },
          {
            type: "STOP_ACTIVITY_BUTTON",
            field: "action_button",
            header: "Interrompi attività",
            icon: "pi pi-times",
          },
          {
            type: "ACTION_BUTTON",
            field: "action_button",
            header: "Codice QR",
            icon: "pi pi-th-large",
          },
        ];
      } else {
        this.cols = [
          { field: "Nome", header: "Nome" },
          { field: "Cognome", header: "Cognome" },
          { field: "Codice_fiscale", header: "Codice Fiscale" },
          { field: "Ragione_sociale", header: "Azienda" },
          {
            type: "ACTION_BUTTON",
            field: "action_button",
            header: "Codice QR",
            icon: "pi pi-th-large",
          },
        ];
      }
    } else if (this.itemType == Enum.DATA_TABLE_TYPE_ENUM.MEZZO_ACCESSI) {
      let userRole = localStorage.getItem(Constants.LS_USER_ROLE);
      // only aggiudicatario and esecutore can stop activity
      if (
        userRole == Enum.USER_TYPE_ENUM.AGGIUDICATARIO ||
        userRole == Enum.USER_TYPE_ENUM.ESECUTORE
      ) {
        this.cols = [
          { field: "Tipo", header: "Tipo" },
          { field: "Definizione", header: "Definizione" },
          { field: "Targa", header: "Targa" },
          { field: "Marca", header: "Marca" },
          { field: "Modello", header: "Modello" },
          { field: "Ragione_sociale", header: "Azienda" },
          {
            type: "STOP_ACTIVITY_BUTTON",
            field: "action_button",
            header: "Interrompi attività",
            icon: "pi pi-times",
          },
          {
            type: "ACTION_BUTTON",
            field: "action_button",
            header: "Codice QR",
            icon: "pi pi-th-large",
          },
        ];
      } else {
        this.cols = [
          { field: "Tipo", header: "Tipo" },
          { field: "Definizione", header: "Definizione" },
          { field: "Targa", header: "Targa" },
          { field: "Marca", header: "Marca" },
          { field: "Modello", header: "Modello" },
          { field: "Ragione_sociale", header: "Azienda" },
          {
            type: "ACTION_BUTTON",
            field: "action_button",
            header: "Codice QR",
            icon: "pi pi-th-large",
          },
        ];
      }
    } else if (this.itemType == Enum.DATA_TABLE_TYPE_ENUM.ATTIVITA_CANTIERE) {
      if (
        localStorage.getItem(Constants.LS_USER_ROLE) ==
        Enum.USER_TYPE_ENUM.AGGIUDICATARIO
      ) {
        this.cols = [
          { field: "Nome", header: "Nome" },
          { field: "Descrizione", header: "Descrizione" },
          { field: "Inizio", header: "Data Inizio" },
          { field: "Fine", header: "Data Fine" },
          { field: "Cantiere.Nome", header: "Cantiere" },
          {
            type: "ACTION_BUTTON",
            field: "action_button",
            header: "Nuovo SAL",
            icon: "pi pi-plus",
          },
        ];
      } else {
        this.cols = [
          { field: "Nome", header: "Nome" },
          { field: "Descrizione", header: "Descrizione" },
          { field: "Inizio", header: "Data Inizio" },
          { field: "Fine", header: "Data Fine" },
          { field: "Cantiere.Nome", header: "Cantiere" },
        ];
      }
    } else if (this.itemType == Enum.DATA_TABLE_TYPE_ENUM.ATTIVITA_COMMESSA) {
      if (
        localStorage.getItem(Constants.LS_USER_ROLE) ==
        Enum.USER_TYPE_ENUM.AGGIUDICATARIO ||
        localStorage.getItem(Constants.LS_USER_ROLE) ==
        Enum.USER_TYPE_ENUM.ESECUTORE
      ) {
        this.cols = [
          { field: "Nome", header: "Nome" },
          { field: "Descrizione", header: "Descrizione", width: "25%" },
          { field: "Inizio", header: "Data Inizio" },
          { field: "Fine", header: "Data Fine" },
          { field: "Commessa.Nome", header: "Commessa" },
          {
            type: "ACTION_BUTTON",
            field: "action_button",
            header: "Nuovo SAL",
            icon: "pi pi-plus",
          },
        ];
      } else {
        this.cols = [
          { field: "Nome", header: "Nome" },
          { field: "Descrizione", header: "Descrizione" },
          { field: "Inizio", header: "Data Inizio" },
          { field: "Fine", header: "Data Fine" },
          { field: "Commessa.Nome", header: "Commessa" },
        ];
      }
    } else if (this.itemType == Enum.DATA_TABLE_TYPE_ENUM.ATTIVITA_SELECTED) {
      this.cols = [
        { field: "Nome", header: "Nome" },
        { field: "Importo", header: "Importo" },
        {
          type: "ACTION_BUTTON",
          field: "action_button",
          header: "Elimina",
          icon: "pi pi-minus",
        },
      ];
    } else if (this.itemType == Enum.DATA_TABLE_TYPE_ENUM.VARIAZIONE_ACCESSI) {
      this.cols = [
        { field: "Codice", header: "Codice" },
        { field: "Tipo", header: "Tipo" },
        { field: "Data_accesso", header: "Data accesso" },
        { field: "Data_variazione", header: "Data variazione" },
        { field: "Tipo_variazione", header: "Tipo variazione" },
        { field: "Utente", header: "Utente" },
        { field: "Ruolo", header: "Ruolo" },
      ];
    } else if (
      this.itemType == Enum.DATA_TABLE_TYPE_ENUM.VARIAZIONE_ACCESSI_ALERT
    ) {
      this.cols = [
        { field: "Cantiere_nome", header: "Cantiere" },
        { field: "Codice", header: "Codice" },
        { field: "Tipo", header: "Tipo" },
        { field: "Data_accesso", header: "Data accesso" },
        { field: "Data_variazione", header: "Data variazione" },
        { field: "Tipo_variazione", header: "Tipo variazione" },
        { field: "Utente", header: "Utente" },
        { field: "Ruolo", header: "Ruolo" },
      ];
    } else if (
      this.itemType == Enum.DATA_TABLE_TYPE_ENUM.VARIAZIONE_RISPOSTE_ALERT
    ) {
      this.cols = [
        { field: "Commessa_nome", header: "Commessa" },
        { field: "Cantiere_nome", header: "Cantiere" },
        { field: "Richiesta_nome", header: "Richiesta" },
        { field: "Modulo_nome", header: "Modulo" },
        { field: "Domanda", header: "Domanda" },
        { field: "Risposta_precedente", header: "Risposta precedente", width: "15%" },
        { field: "Risposta_nuova", header: "Risposta nuova" },
        { field: "Data_variazione", header: "Data variazione" },
        { field: "Azienda_nome", header: "Autore modifica" },
      ];
    } else if (
      this.itemType == Enum.DATA_TABLE_TYPE_ENUM.DOCUMENTO_VARIAZIONE
    ) {
      if (
        localStorage.getItem(Constants.LS_USER_ROLE) ==
        Enum.USER_TYPE_ENUM.AMMINISTRATORE
      ) {
        this.cols = [
          { field: "Nome", header: "Nome", width: "10%" },
          { field: "Descrizione", header: "Descrizione", width: "15%" },
          { field: "Richiesta.Riferimento", header: "Richiesta", width: "15%" },
          {
            field: "Richiesta.Commessa.Nome",
            header: "Commessa",
            width: "15%",
          },
          { field: "Data_scadenza", header: "Data Scadenza", width: "15%" },
          {
            type: "MARKER",
            field: "StatoModulo.Nome",
            header: "Stato",
            width: "10%",
          },
          {
            type: "SHOW_BUTTON",
            field: "show_button",
            header: "Mostra PDF",
            icon: "pi pi-file",
            width: "5%",
          },
        ];
      } else {
        this.cols = [
          { field: "Nome", header: "Nome", width: "10%" },
          { field: "Descrizione", header: "Descrizione", width: "15%" },
          { field: "Richiesta.Riferimento", header: "Richiesta", width: "15%" },
          {
            field: "Richiesta.Commessa.Nome",
            header: "Commessa",
            width: "15%",
          },
          { field: "Data_scadenza", header: "Data Scadenza", width: "15%" },
          {
            type: "MARKER",
            field: "StatoModulo.Nome",
            header: "Stato",
            width: "10%",
          },
          {
            type: "SHOW_BUTTON",
            field: "show_button",
            header: "Mostra PDF",
            icon: "pi pi-file",
            width: "5%",
          },
          {
            type: "ACTION_BUTTON",
            field: "action_button",
            header: "Invia",
            icon: "pi pi-arrow-right",
            width: "5%",
          },
        ];
      }
    } else if (this.itemType == Enum.DATA_TABLE_TYPE_ENUM.GRUPPO) {
      if (
        localStorage.getItem(Constants.LS_USER_ROLE) ==
        Enum.USER_TYPE_ENUM.AMMINISTRATORE
      ) {
        this.cols = [
          {
            type: "EXPAND_ARROW",
            field: "expand_arrow",
            header: "",
            width: "3em",
          },
          { field: "Nome", header: "Nome" },
          { field: "Descrizione", header: "Descrizione" },
          { field: "Ruolo.Ruolo", header: "Ruolo" },
          { 
            type: "COMMESSE_BUTTON", 
            field: "CommesseAssociate", 
            header: "Interventi",
            icon: "pi pi-search",
            width: "6.5em",
          },
          {
            type: "ACTION_BUTTON",
            field: "action_button",
            header: "Modifica",
            icon: "pi pi-pencil",
          },
          {
            type: "DELETE_BUTTON",
            field: "delete_button",
            header: "Elimina",
            icon: "pi pi-trash",
          },
        ];
      } else {
        this.cols = [
          {
            type: "EXPAND_ARROW",
            field: "expand_arrow",
            header: "",
            width: "3em",
          },
          { field: "Nome", header: "Nome" },
          { field: "Descrizione", header: "Descrizione" },
          { field: "Ruolo.Ruolo", header: "Ruolo" },
          { field: "CommesseAssociate", header: "Commesse" },
        ];
      }
    } else if (this.itemType == Enum.DATA_TABLE_TYPE_ENUM.UTENTE) {
      if (
        localStorage.getItem(Constants.LS_USER_ROLE) ==
        Enum.USER_TYPE_ENUM.AMMINISTRATORE
      ) {
        this.cols = [
          {
            type: "EXPAND_ARROW",
            field: "expand_arrow",
            header: "",
            width: "3em",
          },
          { field: "Nome", header: "Nome" },
          { field: "Cognome", header: "Cognome" },
          { field: "UserName", header: "Username" },
          { field: "Email", header: "Email" },
          { field: "GruppiAssociati", header: "Gruppi" },
          { field: "Ruolo.Ruolo", header: "Ruolo" },
          {
            type: "ACTION_BUTTON",
            field: "action_button",
            header: "Modifica",
            icon: "pi pi-pencil",
          },
          {
            type: "DELETE_BUTTON",
            field: "delete_button",
            header: "Elimina",
            icon: "pi pi-trash",
          },
        ];
      } else {
        this.cols = [
          { field: "Nome", header: "Nome" },
          { field: "Cognome", header: "Cognome" },
          { field: "UserName", header: "Username" },
          { field: "Email", header: "Email" },
          { field: "GruppiAssociati", header: "Gruppi" },
          { field: "Ruolo.Ruolo", header: "Ruolo" },
        ];
      }
    } else if (this.itemType == Enum.DATA_TABLE_TYPE_ENUM.UTENTI_REF) {
      this.cols = [
        { field: "Nome", header: "Nome" },
        { field: "Cognome", header: "Cognome" },
        { field: "UserName", header: "Username" },
        { field: "Email", header: "Email" },
        {
          type: "ACTION_BUTTON",
          field: "action_button",
          header: "Modifica",
          icon: "pi pi-pencil",
        },
        {
          type: "DELETE_BUTTON",
          field: "delete_button",
          header: "Elimina",
          icon: "pi pi-trash",
        },
      ];
    } else if (this.itemType == Enum.DATA_TABLE_TYPE_ENUM.LOG_ATTIVITA) {
      if (
        localStorage.getItem(Constants.LS_USER_ROLE) ==
        Enum.USER_TYPE_ENUM.AMMINISTRATORE
      ) {
        this.cols = [
          { field: "User", header: "Utente" },
          { field: "Operazione", header: "Operazione" },
          { field: "DataOperazione", header: "Data Operazione" },
          { field: "Entity", header: "Attività" },
          { field: "Oldvalue", header: "Da" },
          { field: "NewValue", header: "A" },
        ];
      }
    } else if (this.itemType == Enum.DATA_TABLE_TYPE_ENUM.ALLEGATI) {
      // Modifica del 07/11/2024 - Tolto Affidatario perchè avrà un case suo, visto che è l'unico che può cancellare file
      if (
        localStorage.getItem(Constants.LS_USER_ROLE) ==
        Enum.USER_TYPE_ENUM.GVS ||
        localStorage.getItem(Constants.LS_USER_ROLE) ==
        Enum.USER_TYPE_ENUM.CSE ||
        // Modifica del 07/11/2024 - Aggiunto ruolo DL, esecutore e referente
        localStorage.getItem(Constants.LS_USER_ROLE) ==
        Enum.USER_TYPE_ENUM.ESECUTORE ||
        localStorage.getItem(Constants.LS_USER_ROLE) ==
        Enum.USER_TYPE_ENUM.REFERENTE ||
        localStorage.getItem(Constants.LS_USER_ROLE) == Enum.USER_TYPE_ENUM.DL
      ) {
        this.cols = [
          // Modifica del 12/11/2024 - aggiunta Ragione Sociale
          { field: "RagioneSociale", header: "Rag. Sociale" },
          { field: "Nome", header: "Nome" },
          { field: "Descrizione", header: "Descrizione" },
          // Modifica del 06/11/2024 - Ristretta larghezza colonna al 10%
          { field: "DataInvio", header: "Data Invio", width: "9%" },
          { field: "Commessa.Codice", header: "Commessa" },
          // Modifica del 06/11/2024 - Ristretta larghezza colonna al 10%
          { field: "DataLettura", header: "Data Lettura ", width: "9%" },
          {
            type: "ACTION_BUTTON",
            field: "action_button",
            header: "Visualizza",
            icon: "pi pi-file",
          },
        ];
      } else if (
        localStorage.getItem(Constants.LS_USER_ROLE) ==
        Enum.USER_TYPE_ENUM.AGGIUDICATARIO ||
        localStorage.getItem(Constants.LS_USER_ROLE) ==
        Enum.USER_TYPE_ENUM.PREFETTURA
      ) {
        this.cols = [
          // Modifica del 12/11/2024 - aggiunta Ragione Sociale
          { field: "RagioneSociale", header: "Rag. Sociale" },
          { field: "Nome", header: "Nome" },
          { field: "Descrizione", header: "Descrizione" },
          { field: "DataInvio", header: "Data Invio", width: "9%" },
          { field: "Commessa.Codice", header: "Commessa" },
          { field: "DataLettura", header: "Data Lettura ", width: "9%" },
          { type: "MARKER", field: "Stato", header: "Stato", width: "20%" },
          {
            type: "ACTION_BUTTON",
            field: "action_button",
            header: "Visualizza",
            icon: "pi pi-file",
          },
        ];
        // Modifica del 07/11/2024 - Creato Affidatario che è l'unico che può cancellare file
      } else if (
        localStorage.getItem(Constants.LS_USER_ROLE) ==
        Enum.USER_TYPE_ENUM.AFFIDATARIO
      ) {
        this.cols = [
          // Modifica del 12/11/2024 - aggiunta Ragione Sociale
          { field: "RagioneSociale", header: "Rag. Sociale" },
          { field: "Nome", header: "Nome" },
          { field: "Descrizione", header: "Descrizione" },
          // Modifica del 06/11/2024 - Ristretta larghezza colonna al 10%
          { field: "DataInvio", header: "Data Invio", width: "9%" },
          { field: "Commessa.Codice", header: "Commessa" },
          // Modifica del 06/11/2024 - Ristretta larghezza colonna al 10%
          { field: "DataLettura", header: "Data Lettura ", width: "9%" },
          {
            type: "ACTION_BUTTON",
            field: "action_button",
            header: "Visualizza",
            icon: "pi pi-file",
          },
          {
            type: "DELETE_BUTTON",
            field: "delete_button",
            header: "Elimina",
            icon: "pi pi-trash",
          },
        ];
      }
    }
  }

  /**
   * Resets sort, filter and paginator state
   */
  resetTable() {
    if (this.dt) {
      this.dt.reset();
    }
  }

  /**
   * Modifica del 06/11/2024 - Abilita o meno le tooltip nei datatable (default tutte abilitate)
   * @param rowData
   * @param col
   * @returns
   */
  setToolTipDisable(rowData: any, col: any) {
    switch (col.field) {
      case '':
        this.tooltipDisabled = true;
        break;
      default:
        this.tooltipDisabled = false;
        break;
    }
    return this.tooltipDisabled;
  }

  
  isLink(rowData: any, col: any, colIndex: number, isTooltip = false): boolean {
    let isLink: boolean = false;
    if(rowData.isLink && col.header === "Commesse" && colIndex === 4) {
      isLink = true;
    }
    return isLink;
  }

  /**
   * get column value for nested object values
   * @param rowData
   * @param col
   */
  getCellData(
    rowData: any,
    col: any,
    colIndex: number,
    isTooltip = false
  ): any {
    const properties: string[] = col.field.split(",");
    let cellData = "";
    //if itemType is Documento check Valido for status text
    if (
      (this.itemType == Enum.DATA_TABLE_TYPE_ENUM.DOCUMENTO ||
        this.itemType == Enum.DATA_TABLE_TYPE_ENUM.DOCUMENTO_ESECUTORE) &&
      col.field === "Stato"
    ) {
      if (rowData.Valido == null) {
        cellData = "Da Validare";
      } else if (rowData.Valido) {
        cellData = "Valido";
      } else {
        cellData = "Non Valido";
      }
    } else if (
      this.itemType == Enum.DATA_TABLE_TYPE_ENUM.ALLEGATI &&
      col.field == "Stato"
    ) {
      if (rowData.DataLettura) {
        cellData = "Letto";
      } else {
        cellData = "Da leggere";
      }
    } else if (
      this.itemType == Enum.DATA_TABLE_TYPE_ENUM.COMMESSA &&
      col.field == "count" &&
      !rowData.count
    ) {
      cellData = " - ";
      // Modifica del 12/11/2024 - Aggiunta gestione della Ragione Sociale
    } else if (
      this.itemType == Enum.DATA_TABLE_TYPE_ENUM.ALLEGATI &&
      col.field == "RagioneSociale"
    ) {
      cellData = rowData.Mittente.RagioneSociale;
    } else {
      //foreach properties (length > 1 if col has ',')
      for (let i = 0; i < properties.length; i++) {
        let value: any = rowData;
        const nestedProperties: string[] = properties[i].split(".");
        for (const prop of nestedProperties) {
          if (value[prop]) {
            value = value[prop];
          } else {
            value = value[prop] == 0 ? value[prop] : "";
            break;
          }
        }
        if (value != 0 && !value) {
          value = "";
        } else {
          //check if this cell data is document type (CO or CA)
          if (value == Enum.REQUEST_TYPE_FOR_ENUM.CANTIERE) {
            value = Enum.REQUEST_TYPE_FOR_NAME_ENUM.CANTIERE;
          } else if (value == Enum.REQUEST_TYPE_FOR_ENUM.COMMESSA) {
            value = Enum.REQUEST_TYPE_FOR_NAME_ENUM.COMMESSA;
          }
        }
        cellData += value;
        if (i < properties.length - 1 && cellData != "") {
          cellData += " - ";
        }
      }

      // format date if this column contains date value
      let valueMoment = Moment(cellData, "YYYY-MM-DDTHH:mm:ssZ", true);
      if (valueMoment.isValid()) {
        if (
          ((this.itemType == Enum.DATA_TABLE_TYPE_ENUM.VARIAZIONE_ACCESSI ||
            this.itemType ==
            Enum.DATA_TABLE_TYPE_ENUM.VARIAZIONE_ACCESSI_ALERT ||
            this.itemType ==
            Enum.DATA_TABLE_TYPE_ENUM.VARIAZIONE_RISPOSTE_ALERT) &&
            col.field == "Data_variazione") ||
          (this.itemType == Enum.DATA_TABLE_TYPE_ENUM.LOG_ATTIVITA &&
            col.field == "DataOperazione") ||
          (this.itemType == Enum.DATA_TABLE_TYPE_ENUM.ALLEGATI &&
            (col.field == "DataInvio" || col.field == "DataLettura")) ||
          ((this.itemType == Enum.DATA_TABLE_TYPE_ENUM.UPLOADS_MEZZI ||
            this.itemType == Enum.DATA_TABLE_TYPE_ENUM.UPLOADS_PERSONE) &&
            (col.field == "DataInizioCaricamento" ||
              col.field == "DataFineCaricamento"))
        ) {
          cellData = valueMoment.format("DD/MM/YYYY HH:mm");
        } else {
          cellData = valueMoment.format("DD/MM/YYYY");
        }
      }
    }
    // Modifica del 12/11/2024 - Aggiunta gestione del testo mostrato nelle celle delle tabelle che deve essere troncato se supera la larghezza delle colonne
    return this.getTextWidth(cellData) > this.columnWidths[colIndex] &&
      isTooltip === false
      ? this.truncateText(
        cellData,
        this.columnWidths[colIndex]
      )
      : cellData;
  }

  /**
   * Modifica del 12/11/2024 - Aggiunto metodo per recuperare la lunghezza del testo in pixel
   * @param text 
   * @param font 
   * @returns 
   */
  getTextWidth(text, font = "14px Open Sans") {
    // Crea un canvas temporaneo
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    // Imposta il font per il contesto 2D del canvas
    context.font = font;
    // Misura il testo e restituisci la larghezza in pixel
    const metrics = context.measureText(text);
    // Modifica del 03/12/2024 - Ridotto margine testo
    return Math.ceil(metrics.width) + 18;
  }

  /**
   * Modifica del 12/11/2024 - Aggiunto metodo che tronca la stringa se supera la larghezza della colonna
   * @param text 
   * @param larghezzaMax 
   * @param font 
   * @returns 
   */
  truncateText(text, larghezzaMax, font = "14px Open Sans") {
    // Crea un canvas temporaneo per calcolare la larghezza del testo
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    context.font = font;
    let currentText = text;
    // Riduci gradualmente la lunghezza della stringa finché non rientra
    while (this.getTextWidth(currentText) > larghezzaMax) {
      // Rimuovi un carattere alla fine e aggiungi "..."
      currentText = currentText.slice(0, -1);
    }
    // Aggiungi i puntini di sospensione se il testo è stato troncato
    return currentText.length < text.length
      ? `${currentText}..`
      : currentText;
  }

  /**
   * get class based on table type and entity status
   * @param rowData
   */
  getClass(rowData: any) {
    let rowClass = "test";
    if (
      this.itemType == Enum.DATA_TABLE_TYPE_ENUM.RICHIESTA ||
      this.itemType == Enum.DATA_TABLE_TYPE_ENUM.RICHIESTA_TAB_ESECUTORI
    ) {
      let richiesta: IRichiesta = rowData;
      switch (rowData.Stato || richiesta.StatoRichiesta.Nome) {
        case Enum.REQUEST_STATE_NAME_ENUM.APPROVATO:
          rowClass = "circle-green";
          break;
        case Enum.REQUEST_STATE_NAME_ENUM.IN_LAVORAZIONE:
          rowClass = "circle-blue";
          break;
        case Enum.REQUEST_STATE_NAME_ENUM.BOZZA:
          rowClass = "circle-yellow";
          break;
        case Enum.REQUEST_STATE_NAME_ENUM.NON_VALIDO:
          rowClass = "circle-red";
          break;
      }
    } else if (this.itemType == Enum.DATA_TABLE_TYPE_ENUM.SCADENZARIO) {
      let documento: IDocumento = rowData;
      switch (documento.Stato) {
        case Enum.SCADENZARIO_STATE_ENUM.VALIDO:
          rowClass = "warning"; //warning allegati
          break;
        case Enum.SCADENZARIO_STATE_ENUM.IN_SCADENZA:
          rowClass = "circle-yellow";
          break;
        case Enum.SCADENZARIO_STATE_ENUM.SCADUTO:
          rowClass = "circle-red";
          break;
      }
    } else if (
      this.itemType == Enum.DATA_TABLE_TYPE_ENUM.DOCUMENTO ||
      this.itemType == Enum.DATA_TABLE_TYPE_ENUM.DOCUMENTO_ESECUTORE
    ) {
      let documento: IDocumento = rowData;
      if (documento.Valido == null) {
        rowClass = "circle-yellow";
      } else if (documento.Valido) {
        rowClass = "circle-green";
      } else {
        rowClass = "circle-red";
      }
    } else if (
      this.itemType == Enum.DATA_TABLE_TYPE_ENUM.DOCUMENTO_VARIAZIONE
    ) {
      let documento: IDocumento = rowData;
      switch (documento.StatoModulo.Nome) {
        case Enum.DOCUMENTO_VARIAZIONE_STATE_NAME_ENUM.APPROVATO:
          rowClass = "circle-green";
          break;
        case Enum.DOCUMENTO_VARIAZIONE_STATE_NAME_ENUM
          .VARIAZIONE_IN_LAVORAZIONE:
          rowClass = "circle-blue";
          break;
        case Enum.DOCUMENTO_VARIAZIONE_STATE_NAME_ENUM.IN_VARIAZIONE:
          rowClass = "circle-yellow";
          break;
        case Enum.DOCUMENTO_VARIAZIONE_STATE_NAME_ENUM.VARIAZIONE_NON_APPROVATA:
          rowClass = "circle-red";
          break;
      }
    } else if (this.itemType == Enum.DATA_TABLE_TYPE_ENUM.ALLEGATI) {
      let allegato: any = rowData;
      if (allegato.DataLettura) {
        rowClass = "circle-green";
      } else {
        rowClass = "circle-red";
      }
    } else if (
      this.itemType == Enum.DATA_TABLE_TYPE_ENUM.UPLOADS_MEZZI ||
      this.itemType == Enum.DATA_TABLE_TYPE_ENUM.UPLOADS_PERSONE
    ) {
      let caricamento: ICaricamentoMassivo = rowData;
      if (
        caricamento.TotaleRecordInFile ||
        caricamento.TotaleScarti ||
        caricamento.TotaleCaricati
      ) {
        rowClass = "text-align-center";
      }
    }
    return rowClass;
  }

  /**
   * determines whether the action button must be displayed or not
   * @param rowData
   */
  hasToShowActionButton(rowData: any): boolean {
    let hasToshow: boolean = true;

    if (this.itemType == Enum.DATA_TABLE_TYPE_ENUM.RICHIESTA) {
      let richiesta: IRichiesta = rowData;
      /*show action button if this request state is
       "BOZZA" or "NON_VALIDO" and logged user is ESECUTORE or AGGIUDICATARIO
       "IN_LAVORAZIONE" and logged user id AFFIDATARIO */
      // hasToshow = (((richiesta.StatoRichiesta.Nome == Enum.REQUEST_STATE_NAME_ENUM.BOZZA || richiesta.StatoRichiesta.Nome == Enum.REQUEST_STATE_NAME_ENUM.NON_VALIDO) && (localStorage.getItem(Constants.LS_USER_ROLE) == Enum.USER_TYPE_ENUM.ESECUTORE
      //   || localStorage.getItem(Constants.LS_USER_ROLE) == Enum.USER_TYPE_ENUM.AGGIUDICATARIO))) ||
      //   ((richiesta.StatoRichiesta.Nome == Enum.REQUEST_STATE_NAME_ENUM.IN_LAVORAZIONE || richiesta.StatoRichiesta.Nome == Enum.REQUEST_STATE_NAME_ENUM.APPROVATO )  && localStorage.getItem(Constants.LS_USER_ROLE) == Enum.USER_TYPE_ENUM.AFFIDATARIO)
      switch (richiesta.StatoRichiesta.Nome) {
        case Enum.REQUEST_STATE_NAME_ENUM.BOZZA:
        case Enum.REQUEST_STATE_NAME_ENUM.NON_VALIDO:
          hasToshow =
            localStorage.getItem(Constants.LS_USER_ROLE) ==
            Enum.USER_TYPE_ENUM.ESECUTORE ||
            localStorage.getItem(Constants.LS_USER_ROLE) ==
            Enum.USER_TYPE_ENUM.AGGIUDICATARIO;

          break;
        case Enum.REQUEST_STATE_NAME_ENUM.IN_LAVORAZIONE:
        case Enum.REQUEST_STATE_NAME_ENUM.APPROVATO:
          hasToshow =
            localStorage.getItem(Constants.LS_USER_ROLE) ==
            Enum.USER_TYPE_ENUM.AFFIDATARIO ||
            localStorage.getItem(Constants.LS_USER_ROLE) ==
            Enum.USER_TYPE_ENUM.GVS ||
            localStorage.getItem(Constants.LS_USER_ROLE) ==
            Enum.USER_TYPE_ENUM.CSE;
          break;
      }
    } else if (this.itemType == Enum.DATA_TABLE_TYPE_ENUM.DOCUMENTO) {
      let documentoSelected: IDocumento = rowData;
      if (
        this.fromFullTextSearch &&
        (localStorage.getItem(Constants.LS_USER_ROLE) ==
          Enum.USER_TYPE_ENUM.PREFETTURA ||
          localStorage.getItem(Constants.LS_USER_ROLE) ==
          Enum.USER_TYPE_ENUM.DL)
      ) {
        hasToshow = false;
      } else if (!documentoSelected.DocumentoCreato) {
        //show if document is created
        hasToshow = false;
      }
    } else if (
      this.itemType == Enum.DATA_TABLE_TYPE_ENUM.COMMESSA ||
      this.itemType == Enum.DATA_TABLE_TYPE_ENUM.COMMESSA_NO_COUNT
    ) {
      if (
        localStorage.getItem(Constants.LS_USER_ROLE) != Enum.USER_TYPE_ENUM.AFFIDATARIO 
        && localStorage.getItem(Constants.LS_USER_ROLE) != Enum.USER_TYPE_ENUM.GVS 
        && localStorage.getItem(Constants.LS_USER_ROLE) != Enum.USER_TYPE_ENUM.CSE 
        && localStorage.getItem(Constants.LS_USER_ROLE) != Enum.USER_TYPE_ENUM.AMMINISTRATORE
      ) {
        hasToshow = false;
      }
    }
    return hasToshow;
  }

  /**
   * callback fired when one row is selected
   * @param event
   */
  onRowSelect(event) {
    //emit onRowSelected callback
    this.onRowSelected.emit(event.data);
  }

  /**
   * callback fired when one row is unselected
   * @param event
   */
  onRowUnselect(event) {
    //emit onRowUnselected callback
    this.onRowUnselected.emit();
  }

  /**
   * callback fired when one action button is clicked
   * @param rowData
   */
  onActionButtonClick(rowData) {
    this.onActionButtonClicked.emit(rowData);
  }
  
  /**
   * callback fired when one action button is clicked
   * @param rowData
   */
  onActionLinkClick(rowData) {
    this.onActionLinkClicked.emit(rowData);
  }

  onShowButtonClick(rowData) {
    this.onShowButtonClicked.emit(rowData);
  }

  /**
   * click search button
   * visible only full text search
   */
  onClickSearch() {
    this.onClickSearchClicked.emit(this.searchString);
  }

  /**
   * determines whether the link button must be displayed or not
   * @param rowData
   */
  hasToShowLinkButton(rowData): boolean {
    let hasToShowLinkButton = false;
    if (this.itemType == Enum.DATA_TABLE_TYPE_ENUM.COMMESSA) {
      let commessa: ICommessa = rowData;
      if (commessa.LinkGIS && commessa.LinkGIS != "") {
        hasToShowLinkButton = true;
      }
    }
    return hasToShowLinkButton;
  }

  /**
   * callback fired when one link button is clicked
   * @param rowData
   */
  onLinkButtonClick(rowData: any) {
    this.onLinkButtonClicked.emit(rowData);
  }

  /**
   * callback fired when  stop activity button is clicked
   * @param rowData
   */
  onStopActivityButtonClick(rowData: any) {
    this.onStopActivityButtonClicked.emit(rowData);
  }

  /**
   * determines whether the duplicate button must be displayed or not
   * @param rowData
   */
  hasToShowDuplicateButton(rowData: any): boolean {
    let hasToshow: boolean = false;
    if (this.itemType == Enum.DATA_TABLE_TYPE_ENUM.DOCUMENTO) {
      let documento: IDocumento = rowData;
      if (documento && documento.Duplicabile != undefined) {
        hasToshow = documento.Duplicabile;
      }
    }
    return hasToshow;
  }

  /**
   * callback fired when one duplicate button is clicked
   * @param rowData
   */
  onDuplicateButtonClick(rowData: any) {
    this.onDuplicateButtonClicked.emit(rowData);
  }

  /**
   * determines whether the delete button must be displayed or not
   * @param rowData
   */
  hasToShowDeleteButton(rowData: any): boolean {
    let hasToShowDeleteButton = false;
    if (this.itemType == Enum.DATA_TABLE_TYPE_ENUM.RICHIESTA) {
      let richiesta: IRichiesta = rowData;
      // only request in draft can be deleted
      if (this.isAdmin) {
        hasToShowDeleteButton =
          richiesta.StatoRichiesta.Nome == Enum.REQUEST_STATE_NAME_ENUM.BOZZA ||
          richiesta.StatoRichiesta.Nome ==
          Enum.REQUEST_STATE_NAME_ENUM.IN_LAVORAZIONE;
      } else {
        hasToShowDeleteButton =
          richiesta.StatoRichiesta.Nome == Enum.REQUEST_STATE_NAME_ENUM.BOZZA;
      }
    } else if (this.itemType == Enum.DATA_TABLE_TYPE_ENUM.GRUPPO) {
      hasToShowDeleteButton = true;
    } else if (this.itemType == Enum.DATA_TABLE_TYPE_ENUM.UTENTE) {
      let userGuid = localStorage.getItem(Constants.LS_USER_GUID);
      let utente: IUtente = rowData;
      if (utente.Id != userGuid.toLowerCase()) {
        hasToShowDeleteButton = true;
      } else {
        hasToShowDeleteButton = false;
      }
    } else if (this.itemType == Enum.DATA_TABLE_TYPE_ENUM.ALLEGATI) {
      hasToShowDeleteButton = true;
    } else if (this.itemType == Enum.DATA_TABLE_TYPE_ENUM.UTENTI_REF) {
      hasToShowDeleteButton = true;
    } else if (this.itemType == Enum.DATA_TABLE_TYPE_ENUM.ESECUTORE_CRUD) {
      hasToShowDeleteButton = true;
    } else if (this.itemType == Enum.DATA_TABLE_TYPE_ENUM.COMMESSA) {
      hasToShowDeleteButton = this.isAdmin;
    }
    return hasToShowDeleteButton;
  }

  /**
   * callback fired when one delete button is clicked
   * @param rowData
   */
  onDeleteButtonClick(rowData: any) {
    this.onDeleteButtonClicked.emit(rowData);
  }

  onChangeInput(rowData: any) {
    rowData.Invalid = false;
  }

  /**
   * change datatablevalue
   */
  changeFullTextInputBooleanValue(valid: boolean) {
    this.inputValid = valid;
  }

  /**
   * (ruolo: Referente)
   * Valida accesso (l'accesso da Programmato andrà in Effettuato)
   * @param accesso
   */
  onValidaAccesso(accesso: IAccesso) {
    this.onValidaAccessoClicked.emit(accesso);
  }

  onInfoValidazione(richiesta: IRichiesta) {
    this.onInfoValidazioneClicked.emit(richiesta);
  }

  /**
   * permette di editare la colonna sito
   */
  onEditButtonClick(accesso: IAccesso) {
    this.editing = true;
    accesso.Editing = true;
  }

  /**
   * salva il sito per un singolo accesso
   * @param rowData accesso
   */
  onSitoSave(accesso: IAccesso) {
    this.editing = false;
    accesso.Editing = false;
    accesso.sito = this.sitoSelected;
    this.sitoSelected = null;
    this.onActionButtonClicked.emit(accesso);
  }

  /**
   * cancella il sito per un singolo accesso
   * @param rowData accesso
   */
  onSitoCancel(accesso: IAccesso) {
    this.editing = false;
    accesso.Editing = false;
  }

  verificaDataPassata(data: string) {
    const dateToValid = Moment(data);
    const currentDate = moment();

    return dateToValid.isBefore(currentDate);
  }

  /**
   * Modifica del 13/11/2024 - Calcola la larghezza delle colonne delle tabelle
   */
  private updateColumnWidths() {
    if (this.dt) {
      const tableElement = this.dt.el.nativeElement;
      const firstRowCells = tableElement.querySelectorAll("thead tr th");
      this.columnWidths = Array.from(firstRowCells).map(
        (cell: HTMLElement) => cell.offsetWidth
      );
    }
  }
}
